type HeaderMap = Record<string, string>
type ReadHeadersPerRequest = () => HeaderMap | undefined

let baseUrl = ''
let readHeadersPerRequest: () => HeaderMap = () => ({})

const isBrowser = typeof window !== 'undefined'

const assertNoApiKey = (headers: HeaderMap) => {
  const hasApiKey = Object.keys(headers).some(
    (name) => name.toLowerCase() === 'x-api-key'
  )
  if (isBrowser && hasApiKey) {
    throw new Error(
      'API keys must not be used in the browser — they will be exposed to end users. ' +
        'Use server-side calls for authenticated endpoints.'
    )
  }
  return headers
}

export const configure = (options: {
  baseUrl: string
  headers?: HeaderMap | ReadHeadersPerRequest
}) => {
  const { headers } = options
  baseUrl = options.baseUrl

  if (typeof headers === 'function') {
    readHeadersPerRequest = () => assertNoApiKey(headers() ?? {})
    return
  }

  readHeadersPerRequest = () => headers ?? {}
  assertNoApiKey(headers ?? {})
}

export const customFetch = async <T>(
  url: string,
  options: RequestInit
): Promise<T> => {
  const normalizedUrl = `${baseUrl.replace(/\/+$/, '')}/v2/${url.replace(/^\/+/, '')}`
  const res = await fetch(normalizedUrl, {
    ...options,
    cache: 'no-store',
    headers: { ...readHeadersPerRequest(), ...options.headers },
  })

  const body = [204, 205, 304].includes(res.status) ? null : await res.text()

  let data: unknown = {}
  if (body) {
    try {
      data = JSON.parse(body)
    } catch {
      data = {}
    }
  }

  return { data, status: res.status, headers: res.headers } as T
}

export default customFetch
